export default __webpack_public_path__ + "static/media/high-tension-icon.156c7694.svg";